import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import MainLayout from './components/MainLayout';
import MyLists from './pages/MyLists';
import ShoppingListPage from './pages/ShoppingList';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import InvitePage from './pages/InvitePage';
import InviteAcceptedPage from './pages/InviteAcceptedPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyPage from './pages/VerifyPage';
import PasswordResetHandler from './pages/PasswordResetHandler';
import SupabaseCallback from './pages/SupabaseCallback';
import { isFeatureEnabled } from './config/features';

function AppContent() {
  const { user, loading } = useAuth();

  console.log('AppContent render:', { user: !!user, loading });

  if (loading) {
    console.log('Showing loading screen');
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
        <Route path="/forgot-password" element={!user ? <ForgotPasswordPage /> : <Navigate to="/" replace />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/password-reset" element={<PasswordResetHandler />} />
        <Route path="/auth/callback" element={<SupabaseCallback />} />
        
        {/* Protected routes with layout */}
        <Route path="/" element={user ? <Navigate to="/shopping" replace /> : <Navigate to="/login" replace />} />
        <Route path="/shopping" element={user ? <MainLayout><MyLists /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="/list/:listId" element={user ? <MainLayout><ShoppingListPage /></MainLayout> : <Navigate to="/login" replace />} />
        
        {/* Task routes - Only accessible if feature is enabled */}
        {isFeatureEnabled('tasks') ? (
          <>
            <Route path="/tasks" element={user ? <MainLayout><Projects /></MainLayout> : <Navigate to="/login" replace />} />
            <Route path="/project/:projectId" element={user ? <MainLayout><ProjectDetail /></MainLayout> : <Navigate to="/login" replace />} />
          </>
        ) : (
          <>
            {/* Redirect task routes to shopping if feature is disabled */}
            <Route path="/tasks" element={<Navigate to="/shopping" replace />} />
            <Route path="/project/:projectId" element={<Navigate to="/shopping" replace />} />
          </>
        )}
        
        <Route path="/invite/:token" element={<InvitePage />} />
        <Route path="/invite-accepted" element={<InviteAcceptedPage />} />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
